/** Constants for Waitlist Create flow (Select Dates step and shared labels). */

export const WAITLIST_SELECT_PLACEHOLDER = 'Select...'

export const CHECK_IN_DATE_LABEL = 'Check-in date'
export const CHECK_OUT_DATE_LABEL = 'Check-out date'

export const CHECK_IN_DATE_REQUIRED = 'Check-in date is required'
export const CHECK_OUT_DATE_REQUIRED = 'Check-out date is required'

export const MINIMUM_NIGHTS_LABEL = 'Minimum nights'
export const MAXIMUM_NIGHTS_LABEL = 'Maximum nights'
export const MINIMUM_NIGHTS_REQUIRED = 'Minimum nights is required'
export const MAXIMUM_NIGHTS_REQUIRED = 'Maximum nights is required'

export const NIGHTS = 'nights'

export const AT_LEAST_ONE_SUITE_REQUIRED = 'At least one suite is required'
export const SUITES_LABEL = 'Suite types'
export const SUITES_SELECTED_LABEL = 'Suites Selected'
